import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 'v013',
    tag: '当季热门 · 美食',
    title: '三分钟学会爆汁小笼包',
    desc: '皮薄馅大，一咬爆汁，厨房小白也能一次成功',
    image:
      'https://readdy.ai/api/search-image?query=Steaming%20bamboo%20steamer%20of%20soup%20dumplings%20on%20a%20warm%20wooden%20table%2C%20rising%20steam%2C%20rich%20red%20and%20amber%20tones%2C%20dark%20moody%20food%20photography%20background%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-food-01&orientation=landscape',
  },
  {
    id: 'v025',
    tag: '治愈时刻 · 萌宠',
    title: '金毛第一次看海 兴奋到原地转圈',
    desc: '带毛孩子去看世界，它笑得比谁都开心',
    image:
      'https://readdy.ai/api/search-image?query=Happy%20golden%20retriever%20running%20on%20a%20sunny%20beach%20at%20golden%20hour%2C%20warm%20orange%20sky%2C%20dark%20cinematic%20contrast%20background%2C%20wide%20editorial%20pet%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-pets-01&orientation=landscape',
  },
  {
    id: 'v017',
    tag: '燃爆现场 · 舞蹈',
    title: '街舞battle 全场沸腾的60秒',
    desc: '音乐一响，身体就自己动了',
    image:
      'https://readdy.ai/api/search-image?query=Street%20dancer%20mid%20move%20in%20a%20dark%20studio%20with%20red%20spotlight%20and%20motion%20blur%2C%20dramatic%20dark%20background%2C%20cinematic%20wide%20composition%2C%20high%20energy%20photography%2C%20high%20detail&width=1600&height=900&seq=hero-dance-01&orientation=landscape',
  },
  {
    id: 'v001',
    tag: '街头现场 · 音乐',
    title: '街头吉他弹唱《晴天》 路人纷纷驻足',
    desc: '音乐真的会让陌生人也变成朋友',
    image:
      'https://readdy.ai/api/search-image?query=Young%20musician%20singing%20with%20an%20acoustic%20guitar%20on%20a%20city%20sidewalk%20at%20dusk%2C%20warm%20streetlight%20bokeh%2C%20dark%20cinematic%20background%2C%20wide%20editorial%20composition%2C%20amber%20tones%2C%20high%20detail&width=1600&height=900&seq=hero-music-01&orientation=landscape',
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const touchStart = useRef(0);
  const timer = useRef<number | null>(null);

  const go = (i: number) => setIndex((i + slides.length) % slides.length);

  useEffect(() => {
    timer.current = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, []);

  const onTouchStart = (e: React.TouchEvent) => {
    touchStart.current = e.touches[0].clientX;
  };
  const onTouchEnd = (e: React.TouchEvent) => {
    const diff = e.changedTouches[0].clientX - touchStart.current;
    if (Math.abs(diff) > 50) go(diff > 0 ? index - 1 : index + 1);
  };

  return (
    <section
      className="relative w-full h-[480px] md:h-[600px] overflow-hidden bg-foreground-950"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {slides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={s.image}
            alt={`${s.title} - 抖音短视频`}
            title={`${s.title} - 抖音短视频`}
            className={`w-full h-full object-cover object-top transition-transform duration-[6000ms] ${
              i === index ? 'scale-105' : 'scale-100'
            }`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/80"></div>
        </div>
      ))}

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div key={index} className="animate-fade-up max-w-3xl w-full">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-5">
            <i className="ri-fire-line"></i>
            {slides[index].tag}
          </span>
          <h1 className="text-3xl md:text-5xl font-black text-background-50 leading-tight mb-4">
            {slides[index].title}
          </h1>
          <p className="text-background-100/90 text-sm md:text-base mb-8 max-w-xl mx-auto">
            {slides[index].desc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to={`/detail/${slides[index].id}`}
              className="inline-flex items-center gap-2 h-11 px-7 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to="/category/music"
              className="inline-flex items-center gap-2 h-11 px-7 rounded-full bg-background-50/15 hover:bg-background-50/25 border border-background-50/40 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              浏览分类
            </Link>
          </div>
        </div>
      </div>

      {/* Arrows */}
      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(index - 1)}
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-background-50/15 hover:bg-background-50/30 border border-background-50/30 text-background-50 items-center justify-center transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(index + 1)}
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-background-50/15 hover:bg-background-50/30 border border-background-50/30 text-background-50 items-center justify-center transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      {/* Indicators */}
      <div className="absolute bottom-8 left-0 right-0 flex items-center justify-center gap-3">
        {slides.map((s, i) => (
          <button
            key={s.id}
            type="button"
            aria-label={`切换到第${i + 1}张`}
            onClick={() => go(i)}
            className="group relative h-1.5 rounded-full overflow-hidden transition-all cursor-pointer bg-background-50/40"
            style={{ width: i === index ? 40 : 14 }}
          >
            {i === index && (
              <span
                className="absolute inset-y-0 left-0 bg-primary-500 rounded-full"
                style={{ animation: 'heroProgress 5.5s linear forwards' }}
              ></span>
            )}
          </button>
        ))}
      </div>
      <style>{`@keyframes heroProgress { from { width: 0 } to { width: 100% } }`}</style>
    </section>
  );
}